import { Drawer, Modal } from "antd";
import LeaveAppliedComponent from "./LeavesAttendance";
import NewJoineeAndExist from "./NewJoineeAndExist";
import { constants } from "../../../../constants/common";
import BonusesAndSalary from "./BonusesAndSalary";
import Reimbursement from "./Reimbursement";
import SalariesHoldArrears from "./SalariesHoldArrears";
import Override from "./Override";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import moment from "moment";

const ComponentModal = ({ open, onClose, stage }) => {
    const [rendemodel, setRendeModel] = useState<any>(false)
    const parasm = useSelector(({ app }) => app?.params)
    const currentMonth = moment(parasm?.selectedMonth || moment().format('MMM YYYY'), 'MMM YYYY').format('MMM YYYY')

    useEffect(() => {
        setRendeModel(open)
    }, [open])

    const ReturnCurrentComponent = ({ stage, isOpen }) => {
        if (!isOpen) {
            return <></>
        }
        if (stage == constants.RUN_PAYROLL_STAGE.leaveAattendance) {
            return <LeaveAppliedComponent onCloseModel={() => {
                setRendeModel(false)
                onClose && onClose()
            }} />
        } else if (stage == constants.RUN_PAYROLL_STAGE.newJoineesExits) {
            return <NewJoineeAndExist />
        } else if (stage == constants.RUN_PAYROLL_STAGE.bonusSalaryRevisions) {
            return <BonusesAndSalary />
        } else if (stage == constants.RUN_PAYROLL_STAGE.reimbursementAdhoc) {
            return <Reimbursement />
        } else if (stage == constants.RUN_PAYROLL_STAGE.salariesOnHold) {
            return <SalariesHoldArrears />
        } else if (stage == constants.RUN_PAYROLL_STAGE.overridePt) {
            return <Override />
        }
    }

    return (
        <>
            {rendemodel && <Drawer title={`${open} - (${currentMonth})`} open={open} onClose={onClose} width={'100%'}
                footer={null} maskClosable={false}>
                <ReturnCurrentComponent key={stage} stage={stage} isOpen={rendemodel} />
            </Drawer>}
        </>
    );
}


export default ComponentModal;